import React from 'react'
import Link from 'gatsby-link'
import { css } from 'emotion'
import styled from 'react-emotion'
import { Button } from '../utils/styles'

const Screen = styled('div')(({ isOpen }) => ({
  backgroundColor: 'rgba(0, 0, 0, .05)',
  bottom: 0,
  height: '100vh',
  left: 0,
  opacity: isOpen ? 1 : 0,
  position: 'absolute',
  transition: 'opacity .3s ease',
  width: '100vw',
  zIndex: -1,
}))

const MenuLink = styled(Link)(({ active }) => ({
  border: 0,
  color: active ? '#000' : '#b8b8b8',
  display: 'block',
  fontFamily: '"Raleway"',
  fontSize: '1.3em',
  letterSpacing: 2,
  padding: 30,
  position: 'relative',
  textAlign: 'center',

  '&::after': {
    backgroundColor: '#eee',
    bottom: 0,
    content: '""',
    display: 'block',
    height: 2,
    left: 'calc(50% - 20px)',
    position: 'absolute',
    width: 40,
  },
}))

const Menu = (props) =>
  <nav
    css={{
      bottom: 0,
      display: props.isOpen ? 'block' : 'none',
      left: 0,
      position: 'fixed',
      right: 0,
      width: '100%',
      zIndex: 5,
    }}
  >
    <Screen isOpen={props.isOpen} onClick={() => props.menuToggle()} />
    <ul
      css={{
        backgroundColor: '#fff',
        boxShadow: '0 -10px 20px rgba(0, 0, 0, .1), 0 -30px 40px rgba(0, 0, 0, .1)',
        listStyle: 'none',
        margin: 0,
        padding: '0 30px 30px',
        transform: props.isOpen ? 'translateY(0)' : 'translateY(150%)',
        transition: 'transform .3s ease',

        li: { margin: 0 },
      }}
    >
      <li>
        <MenuLink
          onClick={() => props.menuToggle()}
          active={props.pathname === '/' ? 1 : 0}
          to="/"
        >
          Home
        </MenuLink>
      </li>
      <li>
        <MenuLink
          onClick={() => props.menuToggle()}
          active={props.pathname === '/portfolio' ? 1 : 0}
          to="/portfolio"
        >
          Portfolio
        </MenuLink>
      </li>
      <li>
        <MenuLink
          onClick={() => props.menuToggle()}
          active={props.pathname === '/about' ? 1 : 0}
          to="/about"
        >
          About
        </MenuLink>
      </li>
      <li>
        <a
          className={Button}
          href="mailto:contacto@patriciamarques.me"
          title="Get in touch"
        >
          Contact
        </a>
      </li>
    </ul>
  </nav>

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js